const initialState = {
  loading: false,
  account: null,
  smartContract: null,
  smartContract2: null,
  web3: null,
  errorMsg: "",
};

const blockchainReducer = (state = initialState, action) => {
  switch (action.type) {
    case "CONNECTION_REQUEST":
      return {
        ...initialState,
        loading: true,
      };
    case "CONNECTION_SUCCESS":
      return {
        ...state,
        loading: false,
        account: action.payload.account,
        // account: "0xb4250f715995683c6ea5bc7c5e2cdf9b1601ba3f",
        smartContract: action.payload.smartContract,
        smartContract2: action.payload.smartContract2,
        smartContract3: action.payload.smartContract3,
        web3: action.payload.web3,
      };
    case "CONNECTION_FAILED":
      return {
        ...initialState,
        loading: false,
        errorMsg: action.payload,
      };
    case "UPDATE_ACCOUNT":
      return {
        ...state,
        account: action.payload.account,
      };
    default:
      return state;
  }
};

export default blockchainReducer;
